<template>
	<div class="patient-view message">
		<DirectMessageCard :patient="patient"></DirectMessageCard>
		<SentMessageCard :patient="patient"></SentMessageCard>
		<ScheduledMessageCard :patient="patient"></ScheduledMessageCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-message',
	extends: PatientView,

	computed: {
		...mapGetters('provider', [
			'getPatientMessages'
		]),
		patientMessage() {
			return this.getPatientMessages(this.patient.id).slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
